import React from "react";
import { StyleSheet } from "react-native";

import { Block, Touchable, Typography, palette, spacing } from "@stepapp/ui";

type Params = {
  title?: Maybe<string>;
  selected?: boolean;
  testID?: string;
  onPress: () => void;
};

const SimpleAnswerItem = ({ title, selected, onPress, testID }: Params) => {
  return (
    <Touchable onPress={onPress} style={styles.container} testID={testID}>
      <Block
        justifyCenter
        marginBottom={1}
        paddingLeft={2}
        paddingRight={1.5}
        style={[styles.content, selected && styles.selected]}
      >
        <Block alignCenter row>
          <Block justifyCenter>
            <Typography type={selected ? "white" : "primary"} variant="button">
              {title}
            </Typography>
          </Block>
        </Block>
      </Block>
    </Touchable>
  );
};

export default React.memo(SimpleAnswerItem);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    backgroundColor: palette.common.lightGray,
    borderRadius: spacing.radius,
    flex: 1,
    minHeight: spacing.unit * 9,
  },
  selected: {
    backgroundColor: palette.primary.accent,
    boxShadow:
      "0px 10px 40px rgba(0, 0, 84, 0.07), 0px 21.7776px 23.4221px rgba(0, 0, 84, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 84, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 84, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 84, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 84, 0.0196802)",
  },
});
